<template>
    <div class="portlet">
        <slot name="title">
            <slot name="caption"></slot>
            <slot name="actions"></slot>
        </slot>
        <div class="portlet-body" v-if="hasSlot('body')">
            <slot name="body"></slot>
        </div>
    </div>
</template>
<script>
  /* ============
   * Portlet Component
   * ============
   */
  import SlotMixin from '@/app/mixins/slot'

  export default {
    /**
     * The mixins that the component can use.
     */
    mixins: [
      SlotMixin
    ]
  }
</script>



// WEBPACK FOOTER //
// src/app/components/Portlet.vue